module.exports = __webpack_public_path__ + "static/media/attention_icon_new.624fe854.svg";